const style = {
  findProfessionalHeader: {
    '@media only screen and (max-width: 960px)': {
      '& header': {
        zIndex: 1,
      },
    },
  },
};

export default style;
